// 阶段配置
export const STAGES = [
  {
    id: 1,
    num: '01',
    name: '招聘规划 · 需求',
    modules: [
      { id: 'need-report', name: '人力需求提报' },
      { id: 'need-review', name: '需求评审 · 编制审批' },
      { id: 'jd-library', name: '岗位 JD 标准化' },
      { id: 'channel-plan', name: '招聘渠道规划' },
      { id: 'budget', name: '招聘预算制定' },
    ],
  },
  {
    id: 2,
    num: '02',
    name: '简历获取 · 筛选',
    modules: [
      { id: 'channel-ops', name: '渠道发布 · 流量运营' },
      { id: 'resume-screen', name: '简历初筛' },
      { id: 'talent-pool', name: '人才库沉淀' },
    ],
  },
  {
    id: 3,
    num: '03',
    name: '面试组织 · 评估',
    modules: [
      { id: 'invite', name: '邀约沟通' },
      { id: 'interview-arrange', name: '面试统筹' },
      { id: 'interview-eval', name: '分层面试评审' },
      { id: 'assessment', name: '测评考核' },
      { id: 'interview-result', name: '面试结果同步' },
    ],
  },
  {
    id: 4,
    num: '04',
    name: '录用审批 · Offer',
    modules: [
      { id: 'salary-approval', name: '薪酬定级审批' },
      { id: 'bg-check', name: '背景调查' },
      { id: 'offer-send', name: '发放正式 Offer' },
    ],
  },
  {
    id: 5,
    num: '05',
    name: '入职办理',
    modules: [
      { id: 'pre-onboard', name: '入职前跟进' },
      { id: 'onboard', name: '报到入职手续' },
      { id: 'onboard-guide', name: '新人入职引导' },
    ],
  },
  {
    id: 6,
    num: '06',
    name: '复盘 · 转正闭环',
    modules: [
      { id: 'probation-track', name: '试用期跟踪' },
      { id: 'regularization', name: '转正考核' },
      { id: 'analytics', name: '招聘数据复盘' },
      { id: 'optimize', name: '招聘优化迭代' },
    ],
  },
];

// 顶部导航 8 大模块映射
export const TOP_NAV: Record<string, string> = {
  dashboard: '',
  needs: 'need-report',
  channel: 'channel-ops',
  talent: 'talent-pool',
  interview: 'interview-arrange',
  offer: 'offer-send',
  probation: 'probation-track',
  analytics: 'analytics',
};

// 顶部导航文案
export const TOP_NAV_LABELS: Record<string, string> = {
  dashboard: '工作台',
  needs: '需求',
  channel: '渠道',
  talent: '人才库',
  interview: '面试',
  offer: 'Offer',
  probation: '试用期',
  analytics: '复盘',
};

// 8 大模块卡片
export const DASHBOARD_MODULES = [
  { num: '01', name: '需求管理', desc: '业务部门提报、需求评审、编制审批、JD 标准化、预算制定', count: '48 HC', stage: 'STAGE 1', module: 'need-report', icon: '📋' },
  { num: '02', name: '渠道管理', desc: '内推、招聘平台、校园、猎头、短视频，渠道发布与流量运营', count: '9 渠道', stage: 'STAGE 2', module: 'channel-ops', icon: '🌐' },
  { num: '03', name: '简历筛选', desc: '多渠道简历聚合、智能初筛、标签分类、Talent Pool 沉淀', count: '386 份', stage: 'STAGE 2', module: 'resume-screen', icon: '🔍' },
  { num: '04', name: '面试甄选', desc: '邀约、统筹、初/复/终分层面试、测评、结果同步', count: '142 场', stage: 'STAGE 3', module: 'interview-arrange', icon: '👥' },
  { num: '05', name: '背调与录用', desc: '薪酬定级、背景调查、审批流、风险核查', count: '4 项', stage: 'STAGE 4', module: 'bg-check', icon: '🛡' },
  { num: '06', name: 'Offer 与入职', desc: 'Offer 发放、签约、报到、工位/账号、合同协议', count: '19 份', stage: 'STAGE 5', module: 'offer-send', icon: '📨' },
  { num: '07', name: '试用期 & 转正', desc: '月度跟踪、导师辅导、转正答辩、调岗/解聘', count: '4 在试', stage: 'STAGE 6', module: 'probation-track', icon: '🌱' },
  { num: '08', name: '数据分析复盘', desc: '到岗周期、转化率、渠道成本、留存率、流程优化', count: '5 指标', stage: 'STAGE 6', module: 'analytics', icon: '📊' },
];

// 模块元数据（标题、副标题、阶段）
export const MODULE_META: Record<string, { title: string; subtitle: string; stageBadge: string }> = {
  'need-report':      { title: '人力需求提报',      subtitle: '业务部门提交用人申请 · 明确岗位、人数、到岗时间、预算', stageBadge: 'STAGE 1 · 事前规划' },
  'need-review':      { title: '需求评审 · 编制审批', subtitle: 'HR + 部门负责人 + 管理层审核 · 缺编、新增、预算、优先级', stageBadge: 'STAGE 1 · 事前规划' },
  'jd-library':       { title: '岗位 JD 标准化',    subtitle: '岗位职责 · 任职要求 · 薪酬范围 · 福利 · 汇报关系',     stageBadge: 'STAGE 1 · 事前规划' },
  'channel-plan':     { title: '招聘渠道规划',      subtitle: '内推、平台、校园、猎头、短视频、人才库盘活',           stageBadge: 'STAGE 1 · 事前规划' },
  'budget':           { title: '招聘预算制定',      subtitle: '猎头费 · 平台会员 · 校园宣讲 · 礼品 · 背调',         stageBadge: 'STAGE 1 · 事前规划' },
  'channel-ops':      { title: '渠道发布 · 流量运营', subtitle: '各渠道上架、刷新、主动搜猎、内推激励',                stageBadge: 'STAGE 2 · 引流初筛' },
  'resume-screen':    { title: '简历初筛',          subtitle: '匹配学历、年限、行业、技能、薪资，过滤不符合',       stageBadge: 'STAGE 2 · 引流初筛' },
  'talent-pool':      { title: '人才库沉淀',        subtitle: '未录用优质简历归档 · 标签分类 · 复推激活',           stageBadge: 'STAGE 2 · 引流初筛' },
  'invite':           { title: '邀约沟通',          subtitle: '电话/线上沟通 · 确认时间 · 发送面试通知',           stageBadge: 'STAGE 3 · 核心甄选' },
  'interview-arrange':{ title: '面试统筹',          subtitle: '会议室 · 面试官协调 · 签到 · 候场 · 设备调试',      stageBadge: 'STAGE 3 · 核心甄选' },
  'interview-eval':   { title: '分层面试评审',      subtitle: 'HR 初面 · 业务复面 · 高管终面',                     stageBadge: 'STAGE 3 · 核心甄选' },
  'assessment':       { title: '测评考核',          subtitle: '笔试 · 性格 · 专业技能 · 情景模拟 · 无领导小组',     stageBadge: 'STAGE 3 · 核心甄选' },
  'interview-result': { title: '面试结果同步',      subtitle: '面试官填写评价 · 统一汇总打分 · 淘汰/待定/录用分级', stageBadge: 'STAGE 3 · 核心甄选' },
  'salary-approval':  { title: '薪酬定级审批',      subtitle: '根据职级、经验、市场薪资拟定薪酬 · 走审批流',       stageBadge: 'STAGE 4 · 定人环节' },
  'bg-check':         { title: '背景调查',          subtitle: '履历核实 · 前领导访谈 · 学历核验 · 竞业/违纪核查',   stageBadge: 'STAGE 4 · 定人环节' },
  'offer-send':       { title: '发放正式 Offer',    subtitle: '岗位 · 薪资 · 入职时间 · 试用期 · 报到须知',         stageBadge: 'STAGE 4 · 定人环节' },
  'pre-onboard':      { title: '入职前跟进',        subtitle: '跟进候选人离职进度 · 解答疑问 · 降低放鸽子风险',     stageBadge: 'STAGE 5 · 落地衔接' },
  'onboard':          { title: '报到入职手续',      subtitle: '证件收集 · 合同签订 · 工位账号 · 工牌',             stageBadge: 'STAGE 5 · 落地衔接' },
  'onboard-guide':    { title: '新人入职引导',      subtitle: '公司制度 · 部门介绍 · 导师分配 · 岗位职责',         stageBadge: 'STAGE 5 · 落地衔接' },
  'probation-track':  { title: '试用期跟踪',        subtitle: 'HR + 导师月度跟进 · 记录工作表现',                   stageBadge: 'STAGE 6 · 事后管理' },
  'regularization':   { title: '转正考核',          subtitle: '试用期述职 · 业务评估 · 转正/调岗/解除',             stageBadge: 'STAGE 6 · 事后管理' },
  'analytics':        { title: '招聘数据复盘',      subtitle: '到岗周期 · 转化率 · 渠道成本 · 留存率 · 流失率',     stageBadge: 'STAGE 6 · 事后管理' },
  'optimize':         { title: '招聘优化迭代',      subtitle: '调整低效渠道 · 优化 JD · 改进流程 · 完善人才储备',   stageBadge: 'STAGE 6 · 事后管理' },
};
